module.exports = __webpack_public_path__ + "img/upload-icon.8ebb6a6f.png";